import React, { useState, useContext } from 'react';
import styled from 'styled-components/macro';
import { copyFor } from '../../copy/copy';
import ThemeContext from '../../utils/theming';

import checkIsMobile from '../../utils/detectMobileAccurate';
import downloadVideo from '../../utils/recordVideo/downloadVideo';
import Clipboard from 'react-clipboard.js';

let isMobile = checkIsMobile()

const Input = styled.input`
    border-radius: 2px;
    border: solid 1px #f1f1ee;
    width: 100%;
    max-width: ${!isMobile && '16.6rem'};
    min-width: ${isMobile && '-webkit-fill-available'};
    height: 36px;
    line-height: 36px;
    font-family: Averta;
    font-size: 12px;
    padding: 0 10px;
    appearance: none;

    &:focus {
        outline: none;
        border: 1px solid ${({ theme }) => theme.colors.primary};
    }
`;

const Button = styled.div`
    right: -1px;
    bottom: 1px;
    line-height: 32px;
    padding: 0 10px;
    border-radius: 2px;
    border: solid 1px #f1f1ee;
    width: fit-content;
    height: fit-content;
    min-height: 36px;
    box-sizing: border-box;
    line-height: 34px;

    button {
        border: 0;
        font-size: 14px;
        display: inline-block;
        background: #fff;
        cursor: pointer;
        font-weight: 600;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

        &:hover,
        &:focus {
            outline: none;
        }
    }
`;

const LinkContainer = styled.div`
    max-width: 23rem;
    margin-top: 8px;
    display: flex;
    align-items: center;
    position: relative;

    .downloadButton:hover {
        color: white;
        background: ${({ theme }) => theme.colors.primary};
    }

    .copyLink {
        position: relative;
        margin-right: 1rem;
    }

    button,
    .downloadButton {
        color: ${({ theme }) => theme.colors.primary};
        font-size: 14px;
        text-decoration: none;
        font-weight: 600;
        cursor: pointer;
        font-family: Lato;
    }

    .downloadButton, .spinnerContainer{
        min-width: 5.5rem;
        text-align: center;
    }

    button {
        height: 26px;
        position: absolute;
        transform: translateY(-50%);
        width: 7rem;
        border: none;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff 40%);
        right: 1px;
        padding-left: 2rem;
        text-align: right;
        padding-right: 0;
        outline: none;
    }

    .spinner{
        position: absolute;
        top: 3px;
        margin: 0 1rem;
    }
`;

export default props => {
    const [isCopied, setIsCopied] = useState(false);
    const theme = useContext(ThemeContext)

    return props.downloadIsReady && (
        <LinkContainer style={props.style} theme={theme}>
            <Input defaultValue={props.videoURL} readOnly theme={theme} />
            <div className="copyLink">
                <Clipboard data-clipboard-text={props.videoURL}>
                    <div className="copyLink" onClick={() => setIsCopied(true)}>
                        {!isCopied
                            ? copyFor('footer', 'copy')
                            : copyFor('footer', 'copied')}
                    </div>
                </Clipboard>
            </div>
            {!isMobile && 
                (<Button
                    className="downloadButton"
                    onClick={() => downloadVideo(props.fullVideoURL)}
                >
                    {copyFor('postRecord', 'download', 'recordvideo')}
                </Button>)
            }
        </LinkContainer>
    );
};